import CharCreate from "./charcreate";

export default function ccAttribute(attr: string, part: string) {
    if (!attr) attr = 'none';
    const none = CharCreate.attributes.find(a => a.pfield === 'none');
    const find = CharCreate.attributes.find(a => a.pfield === attr);
    if (find) return find[part];
    return none && none[part] ? none[part] : '';
}
